"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractOffer = void 0;
/**
 * Legally enforceable, formally recorded unilateral or bilateral directive i.e., a policy or agreement.
 */
var ContractOffer = /** @class */ (function () {
    function ContractOffer() {
    }
    return ContractOffer;
}());
exports.ContractOffer = ContractOffer;
